import { LDProvider } from 'launchdarkly-react-client-sdk';
import type { ReactNode } from 'react';
import { useSetupFeatureFlags } from './useSetupFeatureFlags';

export function LaunchDarklyProvider({ children }: { children: ReactNode }) {
	const providerProps = useSetupFeatureFlags();

	return <LDProvider {...providerProps}>{children}</LDProvider>;
}
